{
  "fr": {
    "schoolClass": {
      "actions": {
        "leave": "Quitter la salle de classe"
      },
      "activityViewer": {
        "createdAt": "{dateTime}",
        "createdAtTwelveHour": "{dateTime}",
        "breadcrumb": {
          "activities": "Activités"
        },
        "navigation": {
          "previous": "Activité précédente",
          "next": "Activité suivante"
        },
        "export": {
          "document": "Enregistrer le document",
          "audio": "Enregistrer le fichier audio",
          "image": "Enregistrer l'image"
        },
        "placeholder": {
          "unknownPupil": "Inconnu",
          "unknownWorksheet": "Feuille de travail inconnue"
        },
        "worksheet": {
          "submission": "Remise : {worksheetName}",
          "goToDetailView": "Voir les détails"
        },
        "pupilFeedback": {
          "submission": "Remise : {assignmentName}",
          "unknownAssignment": "Tâche inconnue",
          "averageScore": "ø Valeur de remise :",
          "feedbackLabel": "Feedback",
          "goToDetailView": "Voir les détails"
        },
        "error": {
          "loadingActivities": "Erreur lors du chargement des activités. Veuillez réessayer.",
          "activityNotFound": "Activité non trouvée."
        },
        "converter": {
          "additionalInfo": "Infos supplémentaires et public cible",
          "source": "Source",
          "result": "Résultat",
          "noAudio": "Aucun fichier audio disponible",
          "noOutputText": "Aucun texte de sortie disponible",
          "labels": {
            "text": "Résultat",
            "transcript": "Transcription",
            "summary": "Résumé",
            "translation": "Traduction",
            "audio": "Audio",
            "podcast": "Podcast",
            "lecture": "Conférence",
            "dialog": "Dialogue"
          }
        },
        "textEditor": {
          "untitled": "Document sans titre"
        },
        "pinboardCard": {
          "noContent": "Cette carte n'a pas de contenu.",
          "goToCard": "À la carte"
        },
        "pinboardComment": {
          "noContent": "Ce commentaire n'a pas de contenu.",
          "goToCard": "À la carte"
        },
        "pinboardList": {
          "description": "Cette liste organise des cartes sur un tableau d'affichage et ne contient pas de contenu en soi.",
          "goToBoard": "Au tableau d'affichage"
        },
        "surveyResponse": {
          "anonymous": "Aucune vue détaillée disponible — Les réponses au sondage sont anonymes.",
          "goToResponses": "À l'aperçu des résultats"
        },
        "wordEntry": {
          "wordCloudLabel": "dans le nuage de mots :",
          "goToWordCloud": "Au nuage de mots"
        }
      },
      "activityContent": {
        "loading": "Chargement du contenu...",
        "notSupported": "Aperçu non disponible pour le moment",
        "comingSoon": "Cet aperçu d'outil sera bientôt disponible",
        "emptyState": "Aucun contenu disponible",
        "errors": {
          "unauthorized": "Vous n'avez pas la permission de voir ce contenu",
          "notFound": "Ce contenu n'est plus disponible",
          "loadFailed": "Impossible de charger le contenu",
          "unexpected": "Une erreur inattendue est survenue"
        },
        "chat": {
          "emptyState": "Aucun message dans cette conversation"
        },
        "textEditor": {
          "emptyState": "Ce document est vide"
        },
        "worksheet": {
          "noContent": "Aucun contenu à afficher"
        }
      },
      "activities": {
        "actions": {
          "downloadImage": "Télécharger l'image"
        },
        "labels": {
          "name": "Nom",
          "content": "Contenu",
          "project": "Projet",
          "access": "Accès",
          "createdAt": "Créé le",
          "viewActivity": "Voir l'activité"
        },
        "itemTitles": {
          "pinboardCard": "Nouvelle carte « {name} »",
          "pinboardList": "Nouvelle liste « {name} »",
          "pinboardComment": "Nouveau commentaire sur « {name} »",
          "surveyResponse": "Nouvelle soumission « {name} »",
          "wordEntry": "Nouvelle entrée « {name} »"
        },
        "saveConversation": "Enregistrer la conversation",
        "saveDocument": "Enregistrer le document",
        "saveResponse": "Enregistrer la remise",
        "saveResult": "Enregistrer le résultat",
        "sectionTitle": "Créé récemment",
        "projectSectionTitle": "Activités dans ce projet",
        "projectSectionTooltip": "Cliquez sur une activité pour ouvrir les détails. Vous pouvez facilement télécharger les soumissions et les conversations de chat IA via le menu à trois points.",
        "emptyState": "Il n'y a pas encore d'activités. Dès que tu commences à travailler sur un projet, tu pourras voir tes activités ici.",
        "projectEmptyState": "Il n'y a pas encore d'activités dans ce projet. Dès que vos élèves commenceront à travailler sur le projet, leurs activités apparaîtront ici.",
        "filters": {
          "ariaLabel": "Filtrer les activités",
          "title": "Filtrer les activités",
          "all": "Tout",
          "access": {
            "title": "Accès",
            "label": "Sélectionner l'accès…",
            "ariaLabel": "Filtrer par accès"
          },
          "content": {
            "title": "Contenu",
            "label": "Contenu"
          },
          "status": {
            "title": "Statut",
            "label": "Statut",
            "ariaLabel": "Filtrer par statut",
            "completed": "Terminé",
            "open": "Ouvert"
          },
          "timeframe": {
            "title": "Période",
            "label": "Période",
            "totalPeriod": "Période complète",
            "last7Days": "7 derniers jours",
            "last30Days": "30 derniers jours",
            "thisYear": "Cette année ({year})",
            "lastYear": "L'année dernière ({year})",
            "customRange": "Définir la période"
          }
        }
      },
      "activity": {
        "addPupil": "Ajouter un accès",
        "downloadCodes": "Afficher la liste"
      },
      "alert": {
        "discardedMembershipTitle": "Vous n'êtes plus membre actif de cette salle de classe",
        "discardedMembershipBody": "Tous vos projets ont été terminés. Sans adhésion active, vous ne pouvez pas créer de nouveaux projets.",
        "discardedMembershipProjectBody": "Sans adhésion active, vous ne pouvez plus ouvrir ce projet. Rejoignez à nouveau la classe pour retrouver l'accès.",
        "sharedClassroomAccessItem1": "Les élèves se connectent sur <a href='https://go.fobizz.com' target='_blank'>go.fobizz.com</a>. Vous trouverez ici tous les accès si un élève a perdu le code.",
        "sharedClassroomAccessItem2": "<strong>Attention</strong> : Tous les enseignants utilisent les mêmes codes pour les élèves d'une salle de classe partagée. Assurez-vous de <strong>coordonner</strong> les <strong>modifications</strong> dans la liste avec tous les collègues qui utilisent cette salle de classe.",
        "sharedClassroomAccessTitle": "Gestion des accès dans la salle de classe partagée"
      },
      "classroom": {
        "create": "Créer une salle de classe",
        "createDescription": "Partagez des tâches avec vos élèves et mettez à disposition des outils et du matériel pédagogique pour le traitement.",
        "links": {
          "new": "Créer une salle de classe",
          "back": "Retour",
          "discardedProjects": "Projets terminés",
          "pausedProjectsTab": "Projets en pause",
          "activeProjects": "Projets actuels",
          "projects": "Projets",
          "currentProject": "Projet",
          "members": "Enseignants",
          "accessCodes": "Accès"
        },
        "projectFilter": {
          "ariaLabel": "Filtrer les projets par statut",
          "all": "Tous",
          "active": "Actif",
          "paused": "En pause",
          "ended": "Terminé"
        },
        "info": {
          "classroom": {
            "heading": "Gérer les accès à la salle de classe en conformité avec la protection des données",
            "listItems": "<ol><li>Imprimer et attribuer la liste : notez sur papier qui est qui.</li><li>Distribuer les codes d'accès : un code par personne et par année scolaire.</li><li>Accéder : les élèves se connectent sur <a href='https://go.fobizz.com'>go.fobizz.com</a>.</li></ol>",
            "manage": "Gérer",
            "showAccessCodes": "Afficher les codes d'accès"
          },
          "index": {
            "body": "Dans les salles de classe, les élèves peuvent travailler de manière autonome et sécurisée avec des outils numériques. Voici les possibilités disponibles :",
            "heading": "Outils et IA pour votre classe",
            "option1": "<strong class=\"fw-semibold\">Salle de classe pour 1 an</strong>, plusieurs projets, code d'accès individuel par élève, suppression après 365 jours",
            "option2": "<strong class=\"fw-semibold\">Salle de classe pour 24 h</strong>, un seul projet, lien d'accès unique pour tous, suppression après 24 h"
          }
        },
        "labels": {
          "activateControls": {
            "hours24": "24 h",
            "hours24WithMaximum": "24 h",
            "hours24Full": "24 heures",
            "oneMonthWithMaximum": "1 mois",
            "extend": "Prolonger",
            "reactivate": "Réactiver",
            "stop": "Mettre en pause"
          },
          "model": {
            "name": "Nom de la salle de classe",
            "namePlaceholder": "Entrez le nom...",
            "studentAccess": "Accès élèves"
          },
          "school": "Mon école",
          "shareHint": "Vous pouvez partager la salle de classe avec des collègues après l'avoir créée. Vous trouverez le lien d'invitation dans la section « Enseignant·e·s ».",
          "studentAccessTooltip": "Nombre d'élèves pouvant travailler simultanément dans cette salle de classe. Chaque personne reçoit un code d'accès individuel.",
          "schoolPlaceholder": "Sélectionner une école..."
        },
        "indexTitle": "Salles de classe",
        "pageTitle": "Mes salles de classe",
        "pupil": {
          "loggedInAs": "Connecté en tant que",
          "logout": "Déconnexion"
        }
      },
      "confirmDialog": {
        "deletePupil": {
          "confirmButton": "Supprimer",
          "text": "Cette action est irréversible. Le code d'accès sera supprimé et ne pourra plus être utilisé pour se connecter.",
          "title": "Supprimer l'accès ?"
        },
        "deleteTemplate": {
          "confirmButton": "Supprimer",
          "text": "Cette action est irréversible. Le modèle sera définitivement supprimé et ne sera plus disponible pour de nouveaux projets.",
          "title": "Supprimer le modèle de projet ?"
        },
        "discardProject": {
          "confirmButton": "Supprimer",
          "text": "Cette action est irréversible. Le projet sera définitivement supprimé.",
          "title": "Supprimer le projet ?"
        },
        "finishProject": {
          "confirmButton": "Terminer",
          "text": "Le projet sera terminé et déplacé dans les archives. Vous le retrouverez ensuite dans les projets archivés de la salle de classe.",
          "title": "Terminer le projet ?"
        },
        "leave": {
          "confirmButton": "Quitter",
          "text": "Vous n'aurez alors plus accès à la salle de classe et à son contenu.",
          "title": "Quitter la salle de classe ?"
        },
        "saveAsTemplate": {
          "confirmButton": "Enregistrer",
          "text": "Le projet sera enregistré comme modèle et sera ainsi dissocié de la salle de classe.",
          "title": "Enregistrer le projet comme modèle ?"
        }
      },
      "download": {
        "abbreviation": "Abréviation",
        "accessCode": "Code d'accès",
        "accessCodesForClass": "Codes d'accès pour ",
        "accessCreationInstruction": "Sur app.fobizz.com, vous pouvez facilement créer d'autres accès dans l'aperçu de cette salle de classe.",
        "accessListForClass": "Liste des accès pour",
        "documentNotice": "Ce document est uniquement destiné à vos dossiers et doit être traité de manière confidentielle. Ne partagez jamais de données personnelles de vos élèves en ligne.",
        "goToInstruction": "Aller à : ",
        "needMoreAccess": "Besoin de plus d'accès ?",
        "note": "Note",
        "yourAbbreviation": "Votre abréviation :",
        "yourAccessCode": "Votre code d'accès : "
      },
      "errors": {
        "createFailed": "Le projet n'a pas pu être créé."
      },
      "flash": {
        "accessCodeCopied": "Code d'accès copié dans le presse-papiers",
        "createSuccess": "Le projet a été créé avec succès.",
        "deactivatePupilFailure": "L'accès n'a pas pu être désactivé.",
        "deactivatePupilSuccess": "L'accès a été désactivé avec succès.",
        "deactivateTeacherFailure": "L'accès de l'enseignant·e n'a pas pu être désactivé.",
        "deactivateTeacherSuccess": "L'accès de l'enseignant·e a été désactivé avec succès.",
        "deletePupilFailure": "L'accès n'a pas pu être supprimé.",
        "deletePupilSuccess": "L'accès a été supprimé avec succès.",
        "leaveFailure": "Erreur lors de la sortie de la salle de classe.",
        "leaveSuccess": "Vous avez quitté la salle de classe avec succès.",
        "finishProjectSuccess": "Projet terminé avec succès.",
        "pauseProjectSuccess": "Projet mis en pause avec succès.",
        "resumeProjectSuccess": "Projet activé avec succès.",
        "extendProjectSuccess": "Projet prolongé avec succès.",
        "restoreProjectSuccess": "Projet restauré avec succès.",
        "shareProjectSuccess": "Votre projet a été partagé avec succès.",
        "shareProjectFailure": "Le projet n'a pas pu être partagé.",
        "privateItem": "Les paramètres de partage pour ce contenu ont été mis à jour.",
        "reactivatePupilFailure": "L'accès n'a pas pu être réactivé.",
        "reactivatePupilSuccess": "L'accès a été réactivé avec succès.",
        "reactivateTeacherFailure": "L'accès de l'enseignant·e n'a pas pu être réactivé.",
        "reactivateTeacherSuccess": "L'accès de l'enseignant·e a été réactivé avec succès.",
        "regenerateTokenFailure": "Le code d'accès n'a pas pu être régénéré.",
        "regenerateTokenSuccess": "Le code d'accès a été régénéré avec succès.",
        "remixedItem": "Cet assistant IA a été remixé pour vous et copié dans votre compte.",
        "updateSchoolClassSuccess": "La salle de classe a été mise à jour avec succès.",
        "copyError": "Erreur lors de la copie dans le presse-papiers.",
        "noAccessCode": "Aucun code d'accès disponible.",
        "deleteFailed": "Le projet n'a pas pu être supprimé.",
        "createFromTemplateFailed": "Le projet n'a pas pu être créé à partir du modèle.",
        "saveAsTemplateSuccess": "Le projet a été enregistré avec succès comme modèle.",
        "saveAsTemplateFailed": "Le projet n'a pas pu être enregistré comme modèle.",
        "deleteTemplateSuccess": "Le modèle a été supprimé avec succès.",
        "deleteTemplateFailed": "Le modèle n'a pas pu être supprimé.",
        "updateTemplateSuccess": "Le modèle de projet a été mis à jour.",
        "updateTemplateFailed": "Le modèle de projet n'a pas pu être mis à jour."
      },
      "hints": {
        "aiChatAlert": "Avec le Chat IA, les élèves peuvent également créer leurs propres assistants IA.",
        "projectFiles": "Téléchargez des fichiers que vos élèves peuvent consulter et télécharger dans le projet.",
        "projectItems": "Partagez jusqu'à 10 matériels/assistants avec les élèves.",
        "projectTools": "Pour des raisons de protection des données et techniques, seuls les outils indiqués peuvent actuellement être partagés avec les élèves."
      },
      "labels": {
        "inactivePupil": "Accès désactivé",
        "owner": "Admin",
        "pupilName": "Nom",
        "showQrCode": "Afficher le QR code",
        "activity": "Activité",
        "totalToolsCount": "Activité | Activités",
        "createdAt": "Créé le"
      },
      "members": {
        "actions": {
          "discard": "Désactiver l'accès",
          "undiscard": "Réactiver l'accès"
        },
        "status": {
          "header": "Accès",
          "active": "Accès actif",
          "deactivated": "Accès désactivé"
        },
        "empty": "Aucun·e enseignant·e ajouté·e",
        "schoolAccessExpired": {
          "title": "Invitations impossibles",
          "text": "Cette salle de classe appartient à l'école « {companyName} », pour laquelle il n'existe plus de licence active pour les salles de classe partagées. Les collègues ne peuvent donc plus être invités.",
          "textWithoutSchool": "Il n'existe plus de licence active pour les salles de classe partagées pour cette salle de classe. Les collègues ne peuvent donc plus être invités."
        },
        "invite": {
          "title": "Inviter des enseignants au salle de classe",
          "titleShort": "Inviter des enseignant·e·s",
          "tooltip": "L'invitation est valable uniquement pour cette salle de classe. Le lien est général et non personnel.",
          "retry": "Générer un lien d'invitation",
          "regenerate": "Régénérer",
          "showQrCode": "Afficher le QR code",
          "qrCodeTitle": "QR code",
          "qrCodeAlt": "QR code pour le lien d'invitation",
          "confirmRegenerate": {
            "title": "Régénérer le lien d'invitation",
            "text": "Ici, vous pouvez régénérer le lien d'invitation pour la salle de classe. Veuillez noter que l'ancien lien deviendra alors invalide.",
            "confirm": "Oui, régénérer"
          },
          "flash": {
            "generateFailure": "Le lien d'invitation n'a pas pu être créé.",
            "regenerateSuccess": "Le lien d'invitation a été régénéré.",
            "regenerateFailure": "Le lien d'invitation n'a pas pu être régénéré."
          }
        }
      },
      "modals": {
        "deleteConfirmation": {
          "confirmButton": "Supprimer",
          "projectsInfo": "tous les projets actifs (actuellement {count})",
          "subtitle": "Voulez-vous vraiment supprimer la salle de classe {schoolClassName} ?",
          "text": "La salle de classe sera supprimée pour tous les enseignants participants.",
          "textWithProjects": "La salle de classe sera supprimée pour tous les enseignants participants. De plus, {projectsInfo} seront automatiquement terminés.",
          "title": "Supprimer la salle de classe ?"
        }
      },
      "project": {
        "create": "Créer un nouveau projet",
        "defaults": {
          "descriptionPlaceholder": "Tu peux décrire ta mission de travail plus en détail ici.",
          "name": "Nom du projet",
          "projectNamePlaceholder": "Entrez le nom de la tâche..."
        },
        "heading": {
          "noProject": "Temps pour une petite pause",
          "createFromTemplate": "Introduction à l'IA pour les élèves"
        },
        "share": {
          "button": "Partager",
          "dialogTitle": "Partagez ce projet avec vos collègues",
          "dialogDescription": "Ici, vous pouvez ajouter des enseignant·e·s de la classe {schoolClassName} au projet {projectName}.",
          "dialogDescriptionNoClass": "Ici, vous pouvez ajouter des enseignant·e·s au projet {projectName}."
        },
        "errors": {
          "fileAttachFailed": "\"{filename}\" n'a pas pu être ajouté au projet. Veuillez vérifier le type et la taille du fichier.",
          "fileRemoveFailed": "Le fichier n'a pas pu être supprimé. Veuillez réessayer.",
          "imageUpdateFailed": "L'image du projet n'a pas pu être enregistrée. Veuillez réessayer.",
          "itemLoadFailed": "Le matériel à partager n'a pas pu être chargé. Vous pouvez le sélectionner via « Ajouter du contenu ».",
          "itemUnlockFailed": "Le projet a été créé, mais les paramètres de partage du matériel n'ont pas pu être mis à jour. Veuillez les vérifier dans le matériel."
        },
        "hints": {
          "dropFile": "Glissez-déposez ici ou sélectionnez un fichier.",
          "projectItemsLimitReached": "Vous avez atteint le nombre maximum de 10 matériaux. Supprimez des matériaux pour en ajouter de nouveaux."
        },
        "labels": {
          "activeShort": "Actif pendant",
          "chatFrom": "Chat du",
          "createdBy": "De {name}",
          "dayLabel": "Jour | Jours",
          "description": "Tâche",
          "completed": "Terminé",
          "discardedAt": "Projet terminé",
          "enabledTools": "Outils partagés",
          "members": "Ajouter une enseignante ou un enseignant",
          "membersPlaceholder": "Sélectionner...",
          "membersNoOptions": "Veuillez d'abord ajouter des enseignant·e·s à la salle de classe",
          "membersAllAdded": "Toutes les enseignant·e·s de la classe ont déjà été ajouté·e·s",
          "membersTooltip": "Toutes les enseignantes et tous les enseignants invités à cette salle de classe peuvent être ajoutés à un projet individuel.",
          "end": "Fermer le projet",
          "feedbackGiven": "Feedback donné",
          "files": "Fichiers",
          "history": "Historique et soumissions",
          "replaceImage": "Remplacer l'image",
          "teachers": "Enseignant·e·s",
          "restore": "Restaurer le projet",
          "hourLabel": "Heure",
          "noProject": "Il n'y a actuellement aucune tâche pour vous ici.",
          "noArchivedProjects": "Aucun projet terminé pour le moment.",
          "on": "le",
          "pausedPupil": "Votre enseignant·e peut réactiver le projet.",
          "projectItemResponseSubmissions": "{count} remise | {count} remises",
          "projectActive": "Projet actif",
          "projectActiveFor": "Projet actif pour",
          "projectItems": "Matériel et assistants",
          "projectPaused": "Projet en pause",
          "pausedShort": "En pause",
          "projectPausedSentence": "Le projet est en pause.",
          "pupil": {
            "accessCode": "Code d'accès :",
            "deactivate": "Désactiver l'accès",
            "delete": "Supprimer l'accès",
            "downloadList": "Afficher la liste",
            "reactivate": "Réactiver l'accès",
            "regenerateToken": "Régénérer le code d'accès"
          },
          "draftFrom": "Brouillon du",
          "submittedOn": "Remis le"
        },
        "links": {
          "new": "Créer un projet",
          "newEmpty": "Projet vide",
          "newFromTemplate": "Créer un projet à partir d'un modèle",
          "open": "Ouvrir le projet",
          "remove": "Supprimer le projet",
          "saveAsTemplate": "Enregistrer comme modèle"
        },
        "paragraphs": {
          "createTile": "Partagez une tâche et donnez accès à certains outils et matériaux.",
          "createFromTemplateTile": "Utilisez notre cours d'introduction préparé pour enseigner les bases de la compétence IA.",
          "templateModalDescription": "Choisissez un modèle et obtenez un projet préparé pour votre classe.",
          "pupil": {
            "empty": "Il n'y a pas encore de participants dans cette classe. Partagez le lien d'accès pour commencer."
          }
        },
        "picker": {
          "addButton": "Ajouter du contenu",
          "assistantCatalog": {
            "empty": "Aucun assistant trouvé.",
            "errorLoading": "Les assistants n'ont pas pu être chargés.",
            "tabLabel": "Catalogue d'assistants IA"
          },
          "dialogTitle": "Ajouter du contenu",
          "limitHint": "Maximum {max} contenus par projet. Sélectionnez-en moins.",
          "myContent": {
            "tabLabel": "Mon espace de stockage"
          },
          "searchPlaceholder": "Rechercher du contenu..."
        },
        "pupil": {
          "enabledTools": "Outils partagés",
          "warning": {
            "text": "{title} Votre enseignant·e peut à tout moment voir votre progression actuelle.",
            "title": "Bon à savoir :"
          }
        },
        "shareAlertHeadline": "Accès pour tous les participants :"
      },
      "projectTemplates": {
        "heading": "Modèles de projet",
        "breadcrumb": "Modèles de projet"
      },
      "consentModal": {
        "acknowledge": {
          "hint": "Tape ici pour confirmer",
          "label": "D'accord, j'ai compris"
        },
        "start": "C'est parti"
      },
      "inviteRedeem": {
        "title": "Invitation à la salle de classe {name}",
        "body": "{inviter} t'a invité·e dans la salle de classe {name}.",
        "bodyNoInviter": "Tu as été invité·e dans la salle de classe {name}.",
        "join": "Rejoindre la salle de classe",
        "decline": "Refuser",
        "invalidTitle": "Ce lien d'invitation n'est plus valide.",
        "invalidSubtitle": "Demande un nouveau lien d'invitation au personnel enseignant.",
        "expiredTitle": "Le lien a expiré",
        "expiredSubtitle": "La personne qui gère la salle de classe peut t'envoyer le lien actuel.",
        "expiredConfirm": "OK",
        "errorTitle": "L'invitation n'a pas pu être chargée.",
        "errorSubtitle": "Vérifie ta connexion et réessaie.",
        "retry": "Réessayer",
        "backToOverview": "Aller à « Organiser »",
        "licenseActivateTitle": "1/2 Activer le groupe de licence",
        "licenseActivateBody": "{inviter} vous a invité·e dans la salle de classe {name}.{break}Pour utiliser les salles de classe, vous avez besoin d'une {license}.",
        "licenseActivateBodyNoInviter": "Vous avez été invité·e dans la salle de classe {name}.{break}Pour utiliser les salles de classe, vous avez besoin d'une {license}.",
        "licenseActivateDifferentSchoolBody": "{inviter} t'a invité·e dans la salle de classe {name}.{break}Ton abonnement actif n'appartient pas à l'école de la salle de classe.",
        "licenseActivateDifferentSchoolBodyNoInviter": "Tu as été invité·e dans la salle de classe {name}.{break}Ton abonnement actif n'appartient pas à l'école de la salle de classe.",
        "licenseCodeLabelForSchool": "As-tu un code d'activation à 8 chiffres pour le groupe de licence {school} ?",
        "licenseWrongSchoolTitle": "Le code d'activation que tu as utilisé est valide pour un autre groupe de licence.",
        "licenseWrongSchoolBody": "Pour l'invitation à la salle de classe de {inviter}, tu as besoin du code d'activation pour le groupe de licence {school}.",
        "licenseWrongSchoolBodyNoInviter": "Pour l'invitation à la salle de classe, tu as besoin du code d'activation pour le groupe de licence {school}.",
        "licenseWrongSchoolBodyNoSchool": "Pour l'invitation à la salle de classe de {inviter}, tu as besoin du code d'activation pour le bon groupe de licence.",
        "licenseJoinTitle": "2/2 Rejoindre la salle de classe",
        "licenseJoinBody": "{inviter} vous a invité·e dans la salle de classe {name}. Rejoignez maintenant la salle de classe pour partager des projets.",
        "licenseJoinBodyNoInviter": "Vous avez été invité·e dans la salle de classe {name}. Rejoignez maintenant la salle de classe pour partager des projets.",
        "licenseName": "Licence fobizz",
        "licenseCodeLabel": "Avez-vous déjà un code d'activation à 8 chiffres ?",
        "activateLicense": "Activer la licence",
        "moreAboutGroupLicense": "En savoir plus sur la licence de groupe",
        "groupLicenseUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
        "flash": {
          "joinSuccess": "Invitation acceptée – Bienvenue dans la salle de classe {name}",
          "joinFailure": "Échec de la connexion. Veuillez réessayer.",
          "declined": "L'invitation à la salle de classe a été refusée.",
          "alreadyMember": "Tu es déjà membre de la salle de classe {name}.",
          "differentSchool": "Ce code appartient à une autre école. Il n'est donc pas possible de rejoindre cette salle de classe.",
          "licenseActivated": "Groupe de licence {group} activé avec succès."
        },
        "bodyNoGroup": "{inviter} vous a invité·e dans la salle de classe {name}.",
        "licenseRequired": "Pour utiliser les salles de classe, vous avez besoin d'une licence fobizz."
      }
    }
  }
}
